export enum httpStatus {
  ok = 200,
  unauthorized = 401,
  unprocessablEntity = 422,
}
